module.exports = __webpack_public_path__ + "static/media/vedio-img.c211fa77.jpg";